export const baseUrl = "https://www.belongdigitalsolutions.com";

export const defaultMeta = {
  title: "BelongDigitalSolutions | Premium Digital Marketing Agency",
  description:
    "BelongDigitalSolutions is a premium digital marketing agency delivering growth, performance, and brand authority with modern strategy, content, and creative.",
  image: "/og-image.svg"
};

export const buildCanonical = (path) => `${baseUrl}${path}`;